import { Component, OnInit } from '@angular/core';
import { DeveloperTabsService, Tab } from '../../services/developer-tabs.service';
import { CommonModule } from '@angular/common';
import { Dashboard } from '../developer-tabs-components/dashboard/dashboard';
import { Projects } from '../developer-tabs-components/projects/projects';
import { Units } from '../developer-tabs-components/units/units';
import { CreateUnit } from '../developer-tabs-components/create-unit/create-unit';
import { Sales } from '../developer-tabs-components/sales/sales';
import { Reservations } from '../developer-tabs-components/reservations/reservations';
import { Contracts } from '../developer-tabs-components/contracts/contracts';
import { Installments } from '../developer-tabs-components/installments/installments';
import { Deliveries } from '../developer-tabs-components/deliveries/deliveries';
import { CrmManagement } from '../developer-tabs-components/crm-management/crm-management';
import { CustomerService } from '../developer-tabs-components/customer-service/customer-service';
import { Erp } from '../developer-tabs-components/erp/erp';
import { Reports } from '../developer-tabs-components/reports/reports';
import { Settings } from '../developer-tabs-components/settings/settings';
import { ManageTicketsComponent } from '../tickets/manage-tickets.component';
import { Marketing } from '../../../broker/Components/broker-tabs-Components/marketing/marketing';

@Component({
  selector: 'app-developer-tabs-content',
  standalone: true,
  imports: [
    CommonModule,
    Dashboard,
    Projects,
    Units,
    CreateUnit,
    Sales,
    Reservations,
    Contracts,
    Installments,
    Deliveries,
    CrmManagement,
    CustomerService,
    Erp,
    Reports,
    Settings,
    ManageTicketsComponent,
    Marketing,
  ],
  templateUrl: './developer-tabs-content.html',
  styleUrl: './developer-tabs-content.scss',
})
export class DeveloperTabsContent implements OnInit {
  activeTab: string = '';
  tabs: Tab[] = [];
  offersComponent: any = null;

  constructor(private tabsService: DeveloperTabsService) { }

  ngOnInit(): void {
    this.tabs = this.tabsService.getTabs();
    this.activeTab = this.tabsService.getActiveTab();
    this.ensureOffersComponentLoaded(this.activeTab);
    this.ensureStaffComponentLoaded(this.activeTab);

    this.tabsService.activeTab$.subscribe((tabId) => {
      this.activeTab = tabId;
      this.ensureOffersComponentLoaded(tabId);
      this.ensureStaffComponentLoaded(tabId);
    });
  }

  private ensureOffersComponentLoaded(tabId: string): void {
    if (tabId !== 'offers' || this.offersComponent) return;
    import('../developer-tabs-components/offers/offers').then((m) => {
      this.offersComponent = m.Offers;
    });
  }

  isActiveTab(tabId: string): boolean {
    return this.activeTab === tabId;
  }

  getComponentForTab(tabId: string): any {
    // Import components dynamically based on tab ID
    switch (tabId) {
      case 'dashboard':
        return import('../developer-tabs-components/dashboard/dashboard').then((m) => m.Dashboard);
      case 'projects':
        return import('../developer-tabs-components/projects/projects').then((m) => m.Projects);
      case 'units':
        return import('../developer-tabs-components/units/units').then((m) => m.Units);
      case 'sales':
        return import('../developer-tabs-components/sales/sales').then((m) => m.Sales);
      case 'offers':
        return import('../developer-tabs-components/offers/offers').then((m) => m.Offers);
      case 'marketing':
        return import('../../../broker/Components/broker-tabs-Components/marketing/marketing').then(
          (m) => m.Marketing,
        );
      case 'staff':
        return import('../developer-tabs-components/staff/staff-dashboard.component').then(
          (m) => m.StaffDashboardComponent,
        );
      case 'reservations':
        return import('../developer-tabs-components/reservations/reservations').then(
          (m) => m.Reservations,
        );
      case 'contracts':
        return import('../developer-tabs-components/contracts/contracts').then((m) => m.Contracts);
      case 'installments':
        return import('../developer-tabs-components/installments/installments').then(
          (m) => m.Installments,
        );
      case 'deliveries':
        return import('../developer-tabs-components/deliveries/deliveries').then(
          (m) => m.Deliveries,
        );
      case 'crm-management':
        return import('../developer-tabs-components/crm-management/crm-management').then(
          (m) => m.CrmManagement,
        );
      case 'customer-service':
        return import('../developer-tabs-components/customer-service/customer-service').then(
          (m) => m.CustomerService,
        );
      case 'erp':
        return import('../developer-tabs-components/erp/erp').then((m) => m.Erp);
      case 'reports':
        return import('../developer-tabs-components/reports/reports').then((m) => m.Reports);
      case 'settings':
        return import('../developer-tabs-components/settings/settings').then((m) => m.Settings);
      case 'tickets':
        return import('../tickets/manage-tickets.component').then((m) => m.ManageTicketsComponent);
      default:
        return null;
    }
  }

  staffComponent: any = null;

  private ensureStaffComponentLoaded(tabId: string): void {
    if (tabId !== 'staff' || this.staffComponent) return;
    import('../developer-tabs-components/staff/staff-dashboard.component').then((m) => {
      this.staffComponent = m.StaffDashboardComponent;
    });
  }
}
